import * as yup from 'yup';
import axios from 'axios';

const Extensions = {
    bmp: 'image',
    gif: 'image',
    png: 'image',
    jpg: 'image',
    jpeg: 'image',
    webp: 'image',
    tif: 'image',
    tiff: 'image',
    heic: 'image',
    heif: 'image',
    svg: 'image',
    mp3: 'audio',
    wav: 'audio',
    mp4: 'video',
    avi: 'video',

    pdf: 'application',
    doc: 'application',
    docx: 'application',
    txt: 'text',

    xls: 'application',
    xlsx: 'application',
    csv: 'text'
};
export const FILE_SCHEMA = yup.object().shape({
    title: yup.string().optional(),
    description: yup.string().optional(),
    country_id: yup.string().optional(),
    shared: yup.boolean().required(),
    shared_organizations: yup.array().of(yup.string()).optional(),
    shared_users: yup.array().of(yup.string()).optional()
});

export const FILE_IMPORT_SCHEMA = yup.object().shape({
    files: yup
        .array()
        .of(
            yup.mixed().test('fileType', 'Unsupported file type!', (value) => {
                if (!(value instanceof File)) return false;

                const fileExtension = value.name.split('.').pop().toLowerCase();
                return Object.keys(Extensions).includes(fileExtension);
            })
        )
        .min(1, 'Please select at least one valid file!')
        .test('isArrayOfFiles', 'Invalid files provided!', (value) => {
            if (!value || !Array.isArray(value)) return false;
            return value.every((file) => file instanceof File);
        }),
    shared: yup.boolean().required(),
    country_id: yup.string().optional(),
    shared_organizations: yup.array().of(yup.string()).optional(),
    shared_users: yup.array().of(yup.string()).optional()
});

export const downloadFile = async (fileUrl, fileName, fileExtension, setDownloading) => {
    try {
        setDownloading(true);

        const response = await axios.get(fileUrl, {
            responseType: 'blob'
        });

        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = fileName + '.' + fileExtension || 'downloaded-file.' + fileExtension;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
        console.error('File download failed:', error);
    } finally {
        setDownloading(false);
    }
};

export const getFileExtension = (fileName) => {
    if (!fileName) return '';
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    return fileName.includes('.') ? extension : '';
};

export const getFileNameWithoutExtension = (fileName) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    return lastDotIndex !== -1 ? fileName.substring(0, lastDotIndex) : fileName;
};

export const transformFilesForRequest = (files) => {
    return files?.map((f) => {
        if (f.file_id) {
            return {
                file_id: f.file_id,
                name: '',
                path: '',
                extension: '',
                type: ''
            };
        } else {
            return {
                file_id: '',
                name: f.name,
                path: f.path,
                extension: f.extension,
                type: f.type
            };
        }
    });
};
